export const linksData = [
    {
        "id": "important-link",
        "name": "Important Links",
        "links": [
            {
                "name": "Institute of Chartered Accountants of India (ICAI",
                "url": "http://www.icai.org"
            },
            {
                "name": "Northern India Regional Council of ICAI (NIRC)",
                "url": "https://nirc.icai.org/"
            },
            {
                "name": "Central India Regional Council of ICAI (CIRC)",
                "url": "https://circ.icai.org/"
            },
            {
                "name": "Eastern India Regional Council of ICAI (EIRC)",
                "url": "http://eirc-icai.org/"
            },
            {
                "name": "Southern India Regional Council of ICAI (SIRC)",
                "url": "http://www.sircoficai.org/"
            },
            {
                "name": "Western India Regional Council of ICAI (WIRC)",
                "url": "https://www.icai.org/category/wirc-branches"
            },
            {
                "name": "Institute of Company Secretaries of India",
                "url": "http://www.icsi.edu/"
            },
            {
                "name": "Institute of Cost Accountants of India",
                "url": "http://icmai.in/"
            },
            {
                "name": "Bombay Chartered Accountants Society",
                "url": "http://www.bcasonline.org/"
            },
            {
                "name": "Federation of Indian Chambers of Commerce and Industry",
                "url": "http://www.ficci.com/"
            },
            {
                "name": "The Information System Audit and Control Association & Foundation (ISACA)",
                "url": "http://www.isaca.org/"
            },
            {
                "name": "Industrial Development Bank of India (IDBI)",
                "url": "http://www.idbi.com/"
            },
            {
                "name": "Industrial Finance Corporation of India (IFCI)",
                "url": "http://www.ifciltd.com/"
            },
            {
                "name": "Industrial Investment Bank of India (IIBI)",
                "url": "http://www.iibiltd.com/"
            },
            {
                "name": "Life Insurance Corporation of India (LIC)",
                "url": "https://licindia.in/"
            },
            {
                "name": "Unit Trust of India (UTI)",
                "url": "http://www.utimf.com"
            },
            {
                "name": "Export Import Bank of India (Exim Bank)",
                "url": "http://www.eximbankindia.in/"
            },
            {
                "name": "Housing Development Finance Corporation Ltd. (HDFC)",
                "url": "https://www.hdfc.com/"
            },
            {
                "name": "National Bank for Agricultural & Rural Development (NABARD)",
                "url": "http://www.nabard.org/"
            },
            {
                "name": "Housing & Urban Development Corporation (HUDCO)",
                "url": "https://www.hudco.org.in/index_h.aspx"
            },
            {
                "name": "Small Industries Development Bank of India (SIDBI)",
                "url": "https://www.sidbi.in/en/"
            },
            {
                "name": "Ministry of Finance",
                "url": "https://financialservices.gov.in/beta/en"
            },
            {
                "name": "Ministry of Information Technology",
                "url": "https://meity.gov.in/"
            },
            {
                "name": "Ministry of Law & Justice",
                "url": "http://lawmin.gov.in/"
            },
            {
                "name": "Ministry of Home Affairs",
                "url": "https://mha.gov.in/"
            },
            {
                "name": "Central Board of Direct Taxes",
                "url": "http://incometaxindia.gov.in"
            },
            {
                "name": "Department of Company Affairs(MCA21)",
                "url": "http://www.mca.gov.in/MCA21/"
            },
            {
                "name": "Central Board of Excise & Custom",
                "url": "https://www.cbic.gov.in/"
            },
            {
                "name": "Customs, Excise and Service Tax Appellate Tribunal",
                "url": "https://cestat.gov.in/"
            },
            {
                "name": "Reserve Bank of India (RBI)",
                "url": "http://www.rbi.org.in/"
            },
            {
                "name": "Securities & Exchange Board of India (SEBI)",
                "url": "http://www.sebi.gov.in/"
            },
            {
                "name": "National Stock Exchange (NSE)",
                "url": "http://www.nseindia.com/"
            },
            {
                "name": "Bombay Stock Exchange (BSE)",
                "url": "http://www.bseindia.com/"
            },
            {
                "name": "National Securities Depositories Ltd. (NSDL)",
                "url": "http://www.nsdl.co.in/"
            },
            {
                "name": "Central Depository Services (India) Ltd. (CDSL)",
                "url": "http://www.cdslindia.com/"
            },
            {
                "name": "Comptroller & Auditor General of India",
                "url": "https://cag.gov.in/en"
            },
            {
                "name": "Controller General of Accounts",
                "url": "https://cga.nic.in/"
            },
            {
                "name": "Supreme Court of India",
                "url": "https://sci.gov.in/"
            },
            {
                "name": "High Court, Delhi",
                "url": "http://delhihighcourt.nic.in"
            },
            {
                "name": "High Court,Mumbai",
                "url": "http://bombayhighcourt.nic.in/"
            },
            {
                "name": "Credit Rating Information Services of India Ltd. (CRISIL)",
                "url": "http://www.crisil.com/"
            },
            {
                "name": "ICRA Ltd. (ICRA)",
                "url": "http://www.icra.in/"
            },
            {
                "name": "Credit Analysis & Research Ltd. (CARE)",
                "url": "http://www.careratings.com/"
            },
            {
                "name": "Employees State Insurance Corporation",
                "url": "https://www.esic.gov.in/"
            },
            {
                "name": "Employee Provident Fund",
                "url": "http://epfindia.gov.in/"
            },
            {
                "name": "Labour Department",
                "url": "https://labour.gov.in/"
            },
            {
                "name": "Tax E-Filing",
                "url": "https://www.incometax.gov.in/iec/foportal/"
            },
            {
                "name": "Automation of Central Excise and Service Tax",
                "url": "https://cbic-gst.gov.in/aces/aces.html"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Links/important_links/important_links.aspx"
    },
    {
        "id": "quick-link",
        "name": "Quick Links",
        "links": [
            {
                "name": "Income Tax",
                "url": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Links-IT.aspx"
            },
            {
                "name": "Service Tax/ Excise",
                "url": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Links-ST.aspx"
            },
            {
                "name": "Ministry of Corporate Affairs",
                "url": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Links-MCA.aspx"
            },
            {
                "name": "The Employees' State Insurance",
                "url": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Links-ESI.aspx"
            },
            {
                "name": "Provident Fund",
                "url": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Links-PF.aspx"
            },
            {
                "name": "ICSI",
                "url": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Links-ICSI.aspx"
            },
            {
                "name": "ICAI",
                "url": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Links-ICAI.aspx"
            },
            {
                "name": "ICAI (ICWAI)",
                "url": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Links-ICWAI.aspx"
            },
            {
                "name": "Property Registration",
                "url": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Links-PR.aspx"
            },
            {
                "name": "Others",
                "url": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Links-Others.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Links/Quick_Link/Quick_Link.aspx"
    },
    {
        "id": "ease-doing-business",
        "name": "Ease of Doing Business Links",
        "links": [
            {
                "name": "Income Tax Return File",
                "url": "https://eportal.incometax.gov.in/iec/foservices/#/login"
            },
            {
                "name": "Pay Taxes For Income Tax & TDS",
                "url": "https://eportal.incometax.gov.in/iec/foservices/#/e-pay-tax-prelogin/user-details"
            },
            {
                "name": "Know Your PAN",
                "url": "https://incometaxindia.gov.in/Pages/tax-services/online-pan-verification.aspx"
            },
            {
                "name": "Challan Status Enquiry",
                "url": "https://incometaxindia.gov.in/Pages/tax-services/challan-status.aspx"
            },
            {
                "name": "Status Of Refund",
                "url": "https://tin.tin.nsdl.com/oltas/refundstatuslogin.html"
            },
            {
                "name": "Status Of Quarterly TDS Return",
                "url": "https://onlineservices.tin.egov-nsdl.com/TIN/JSP/tds/linktoUnAuthorizedInput.jsp"
            },
            {
                "name": "E-payment of Taxes",
                "url": "https://onlineservices.tin.egov-nsdl.com/etaxnew/tdsnontds.jsp"
            },
            {
                "name": "PAN (from Name & DOB)",
                "url": "https://incometaxindiaefiling.gov.in/e-Filing/Services/KnowYourPanLink.html"
            },
            {
                "name": "ITR-V Receipt Status",
                "url": "https://www.incometax.gov.in/iec/foportal/help/how-to-know-the-itr-status"
            },
            {
                "name": "Know Your AO",
                "url": "https://www.incometax.gov.in/iec/foportal/help/know-ao"
            },
            {
                "name": "Online New PAN Application/ Correction of PAN",
                "url": "https://tin.tin.nsdl.com/pan/correction.html"
            },
            {
                "name": "TAN Login",
                "url": "https://www.tdscpc.gov.in/app/login.xhtml"
            },
            {
                "name": "OLTAS Challan Status",
                "url": "https://tin.tin.nsdl.com/oltas/index.html"
            },
            {
                "name": "Verify Form 16A",
                "url": "https://onlineservices.tin.egov-nsdl.com/TIN/JSP/form16A/LinkToUnauthorizedView.jsp"
            },
            {
                "name": "Verify Form 16",
                "url": "https://onlineservices.tin.egov-nsdl.com/TIN/JSP/form16/LinkToUnauthorizedView.jsp"
            },
            {
                "name": "Know TAN",
                "url": "https://www.incometax.gov.in/iec/foportal/help/know-tan"
            },
            {
                "name": "Online TAN Application",
                "url": "https://tin.tin.nsdl.com/tan/form49B.html"
            },
            {
                "name": "Online TAN Correction",
                "url": "https://tin.tin.nsdl.com/tan/ChangeRequest.html"
            },
            {
                "name": "Tax E-Filing",
                "url": "https://www.incometax.gov.in/iec/foportal/"
            },
            {
                "name": "E-payment of Service Tax/ Excise",
                "url": "https://www.cbic.gov.in/entities/cbic-content-mst/NjU2MA%3D%3D"
            },
            {
                "name": "Know Challan Status",
                "url": "https://traffic.delhipolice.gov.in/check-noc-status"
            },
            {
                "name": "Assesse Search (Code based)",
                "url": "https://www.cbic.gov.in/entities/cbic-content-mst/NjU2MQ%3D%3D"
            },
            {
                "name": "Assesse Login",
                "url": "https://itat.gov.in/efiling/asselogin"
            },
            {
                "name": "Automation of Central Excise and Service Tax",
                "url": "https://cbic-gst.gov.in/aces/aces.html"
            },
            {
                "name": "Verify Co. Master Data",
                "url": "http://www.mca.gov.in/mcafoportal/login.do"
            },
            {
                "name": "MCA Login",
                "url": "http://www.mca.gov.in/mcafoportal/"
            },
            {
                "name": "Employer Login",
                "url": "https://www.epfindia.gov.in/site_en/For_Employers.php?id=sm1_index"
            },
            {
                "name": "Employees State Insurance Corporation",
                "url": "https://www.esic.gov.in/"
            },
            {
                "name": "Employer Login",
                "url": "https://www.epfindia.gov.in/site_en/For_Employers.php"
            },
            {
                "name": "Know PF Claim Status",
                "url": "https://passbook.epfindia.gov.in/MemberPassBook/login"
            },
            {
                "name": "Know PF Balance",
                "url": "https://passbook.epfindia.gov.in/MemberPassBook/Login.jsp"
            },
            {
                "name": "Employee Registration",
                "url": "https://www.epfindia.gov.in/site_en/For_Employees.php"
            },
            {
                "name": "Pensioners’ Portal",
                "url": "http://pensionersportal.gov.in/"
            },
            {
                "name": "Employee Provident Fund.",
                "url": "http://epfindia.gov.in/site_en/"
            },
            {
                "name": "Labour Department.",
                "url": "https://labour.gov.in/"
            },
            {
                "name": "GST Return File",
                "url": "https://services.gst.gov.in/services/login"
            },
            {
                "name": "GST",
                "url": "https://payment.gst.gov.in/payment/"
            },
            {
                "name": "Service Tax/ Excise",
                "url": "https://cbic-gst.gov.in/"
            },
            {
                "name": "Ministry of Finance",
                "url": "https://asrm.co.in/Ministry of Finance"
            },
            {
                "name": "Ministry of Information Technology",
                "url": "https://meity.gov.in/"
            },
            {
                "name": "Ministry of Law & Justice",
                "url": "http://lawmin.gov.in/"
            },
            {
                "name": "Ministry of Home Affairs",
                "url": "https://mha.gov.in/"
            },
            {
                "name": "Central Board of Direct Taxes",
                "url": "http://incometaxindia.gov.in/Pages/default.aspx"
            },
            {
                "name": "Department of Company Affairs(MCA21)",
                "url": "https://asrm.co.in/Department of Company Affairs(MCA21)"
            },
            {
                "name": "Central Board of Excise & Custom",
                "url": "https://en.wikipedia.org/wiki/Board_for_Industrial_and_Financial_Reconstruction"
            },
            {
                "name": "Customs, Excise and Service Tax Appellate Tribunal",
                "url": "https://cestat.gov.in/"
            },
            {
                "name": "Reserve Bank of India (RBI)",
                "url": "https://www.rbi.org.in/"
            },
            {
                "name": "Securities & Exchange Board of India (SEBI)",
                "url": "http://www.sebi.gov.in/index.html"
            },
            {
                "name": "National Stock Exchange (NSE)",
                "url": "https://www.nseindia.com/"
            },
            {
                "name": "Bombay Stock Exchange (BSE)",
                "url": "http://www.bseindia.com/"
            },
            {
                "name": "National Securities Depositories Ltd. (NSDL)",
                "url": "http://www.nsdl.co.in/"
            },
            {
                "name": "Central Depository Services (India) Ltd. (CDSL)",
                "url": "http://www.cdslindia.com/"
            },
            {
                "name": "Comptroller & Auditor General of India",
                "url": "https://cag.gov.in/en"
            },
            {
                "name": "Controller General of Accounts",
                "url": "https://cga.nic.in/"
            },
            {
                "name": "Supreme Court of India",
                "url": "http://supremecourtofindia.nic.in/"
            },
            {
                "name": "High Coutrt, Delhi",
                "url": "http://delhihighcourt.nic.in/"
            },
            {
                "name": "High Court, Mumbai",
                "url": "http://bombayhighcourt.nic.in/"
            },
            {
                "name": "Credit Rating Information Services of India Ltd. (CRISIL)",
                "url": "http://www.crisil.com/"
            },
            {
                "name": "ICRA Ltd. (ICRA)",
                "url": "http://www.icra.in/"
            },
            {
                "name": "Credit Analysis & Research Ltd. (CARE)",
                "url": "https://www.indiainfoline.com/company/care-ratings-ltd/summary"
            },
            {
                "name": "Employees State Insurance Corporation",
                "url": "http://esic.nic.in/"
            },
            {
                "name": "E-Stamping - Verify Certificate",
                "url": "https://www.shcilestamp.com/eStampIndia/VerifyCertificate.es?rDoAction=VerifyCert"
            },
            {
                "name": "Property Registration (Delhi)",
                "url": "https://doris.delhigovt.nic.in/"
            },
            {
                "name": "Appointment for Property Registration (Delhi)",
                "url": "https://dmnorthwest.delhi.gov.in/service/appointment-management-system-for-property-registration/"
            },
            {
                "name": "Property Registration (Maharastra& Pune)",
                "url": "https://efilingigr.maharashtra.gov.in/ereg/"
            },
            {
                "name": "Indian Courts",
                "url": "https://ecourts.gov.in/ecourts_home/"
            },
            {
                "name": "Online Registration Delhi Shops & Establishments",
                "url": "https://labourcis.nic.in/"
            },
            {
                "name": "E-SLA of Delhi Government",
                "url": "http://esla.delhi.gov.in/"
            },
            {
                "name": "e-Aadhar",
                "url": "https://eaadhaar.uidai.gov.in/"
            },
            {
                "name": "E-file of Copyright Application",
                "url": "http://copyright.gov.in/UserRegistration/frmLoginPage.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Links/EASE_OF_DOING_BUSINESS/EASE_OF_DOING_BUSINESS.aspx"
    },
    {
        "id": "gst-link",
        "name": "GST Links",
        "links": [
            {
                "name": "www.andaman.nic.in",
                "url": "https://andaman.nic.in/"
            },
            {
                "name": "www.apct.gov.in",
                "url": "https://apct.gov.in/GSTPortal/Ap_index.aspx"
            },
            {
                "name": "www.aruntax",
                "url": "https://aruntax.nic.in/gst_notification_ar.html"
            },
            {
                "name": "www.tax.assam.gov.in",
                "url": "https://comtax.assam.gov.in/information-services/gst"
            },
            {
                "name": "www.biharcommercialtax.gov.in",
                "url": "https://state.bihar.gov.in/"
            },
            {
                "name": "www.etdut.gov.in",
                "url": "http://etdut.gov.in/ExciseOnline/index.html"
            },
            {
                "name": "www.comtax.cg.nic.in",
                "url": "https://gstcouncil.gov.in/node/3694"
            },
            {
                "name": "www.dnhctd.gov.in",
                "url": "https://swp.dddgov.in/vat-and-gst-dnhdd"
            },
            {
                "name": "www.goagst.gov.in/comtax_start.html",
                "url": "https://goagst.gov.in/"
            },
            {
                "name": "www.commercialtax.gujarat.gov.in",
                "url": "https://commercialtax.gujarat.gov.in/vatwebsite/home/home.jsp"
            },
            {
                "name": "www.haryanatax.com",
                "url": "https://haryanatax.gov.in/HEX/appmanager/HexPortal/HaryanaExcise"
            },
            {
                "name": "https://www.hptax.gov.in",
                "url": "https://www.hptax.gov.in/"
            },
            {
                "name": "www.jkcomtax.gov.in",
                "url": "https://jkcomtax.gov.in/gst.html"
            },
            {
                "name": "www.jharkhandcomtax.gov.in",
                "url": "https://ctax.jharkhand.gov.in/gst"
            },
            {
                "name": "www.ctax.kar.nic.in",
                "url": "https://gstcouncil.gov.in/node/3793"
            },
            {
                "name": "www.keralataxes.gov.in",
                "url": "https://gstcouncil.gov.in/"
            },
            {
                "name": "www.lakshadweep.nic.in",
                "url": "https://lakshadweep.gov.in/"
            },
            {
                "name": "www.gstcouncil.gov.in/states/madhya-pradesh",
                "url": "https://dsel.education.gov.in/node/2917"
            },
            {
                "name": "www.zotax.nic.in",
                "url": "http://zotax.nic.in/"
            },
            {
                "name": "www.nagalandtax.nic.in",
                "url": "http://nagalandtax.nic.in/taxrates.asp"
            },
            {
                "name": "www.odishatax.gov.in",
                "url": "https://odishatax.gov.in/"
            },
            {
                "name": "www.gst.puducherry.gov.in",
                "url": "https://vat.py.gov.in/e-returns/"
            },
            {
                "name": "www.pextax.com",
                "url": "https://taxation.punjab.gov.in/"
            },
            {
                "name": "www.rajtax.gov.in",
                "url": "http://rajtax.gov.in/"
            },
            {
                "name": "www.sikkimtax.gov.in",
                "url": "https://sikkim.gov.in/departments/finance-revenue-expenditure-department/commercial-tax-division"
            },
            {
                "name": "www.tripurataxes.nic.in",
                "url": "https://gstcouncil.gov.in/hi/node/3751"
            },
            {
                "name": "www.tgct.gov.in/tgportal/",
                "url": "https://www.tgct.gov.in/tgportal/"
            },
            {
                "name": "www.comtax.uk.gov.in",
                "url": "http://comtax.uk.gov.in/"
            },
            {
                "name": "www.comtax.up.nic.in",
                "url": "http://comtax.up.nic.in/"
            },
            {
                "name": "www.wbcomtax.nic.in",
                "url": "https://comtax.wb.gov.in/"
            },
            {
                "name": "www.aruntax.nic.in",
                "url": "https://www.aruntax.nic.in/"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Links/Vat_Links/Vat_Links.aspx"
    }
];


